import { useState } from "react";
import styled from "styled-components";
import { Typography } from "@mui/material";

import AdminForm from "./AdminForm";
import { useSelector } from "react-redux";
import SegmentCards from "./SegmentCards";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 0 20px;
`;

export default function SelectRole({
  brands,
  businessEntityID,
  userID,
  component = "",
  loadingBrands,
}) {
  const { dashboardState } = useSelector((state) => state.memberDetails);

  const role =
    useSelector((state) => state?.memberDetails.role) ||
    sessionStorage.getItem("role");

  const authToken =
    useSelector((state) => state?.memberDetails.authToken) ||
    sessionStorage.getItem("authToken");

  const { brandType, activeBrand } = useSelector(
    (state) => state.memberDetails
  );

  const [currentBrand, setCurrentBrand] = useState({
    ID: activeBrand.ID || brands[0]?.ID,
    name: activeBrand.name || brands[0]?.brandName,
    type: activeBrand.brandType || brandType || brands[0]?.brandType,
  });

  const [userDashboardState, setUserDashboardState] = useState(
    currentBrand.type === 3 ? "promotion" : "monetization"
  );

  return (
    <Wrapper>
      <div style={{ justifyContent: "center" }} className="wrapper-container">
        <Typography className="who">Access Your Workspace</Typography>
      </div>

      {component === "admin" ? (
        <AdminForm
          loadingBrands={loadingBrands}
          brands={brands}
          businessEntityID={businessEntityID}
        />
      ) : (
        <SegmentCards
          component=""
          loadingBrands={loadingBrands}
          role={role}
          userDashboardState={userDashboardState}
          authToken={authToken}
          setUserDashboardState={setUserDashboardState}
          currentBrand={currentBrand}
          setCurrentBrand={setCurrentBrand}
          brands={brands}
          businessEntityID={businessEntityID}
          userID={userID}
        />
      )}
    </Wrapper>
  );
}
